import { render, staticRenderFns } from "./MobileFullscreen.vue?vue&type=template&id=ed55b52e"
import script from "./MobileFullscreen.vue?vue&type=script&lang=js"
export * from "./MobileFullscreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports